import React from 'react';
function Projects(){
    return <>
    <div className="Name">Projects & Clients</div>
    </>
}
export default Projects;